// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2RZ3v","large":"styles_large__3FxJv"};